import React from 'react';

const variants = {
  primary: 'bg-primary-100 text-primary-800',
  secondary: 'bg-gray-100 text-gray-800',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  danger: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  babo: 'bg-orange-100 text-orange-800',
  queso: 'bg-purple-100 text-purple-800',
  beez: 'bg-yellow-100 text-yellow-800',
  des: 'bg-amber-100 text-amber-800',
  kien: 'bg-cyan-100 text-cyan-800'
};

export default function Badge({ children, variant = 'secondary', className = '' }) {
  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
        ${variants[variant] || variants.secondary}
        ${className}
      `}
    >
      {children}
    </span>
  );
}
